<template>
  <div class="navbar" :class="[{ d_none: $route.name === 'dashboard' }]">
    <div class="navbar_top_content">
      <h2>솔루션 <span>관리하기</span></h2>
    </div>
    <ul class="left_nav_list">
      <template
        v-if="
          [
            'members_admin',
            'member_admin_add',
            'member_admin_edit',
            'parent_list',
            'parent_add',
            'parent_edit',
            'student_list',
            'student_add',
            'student_edit',
            'professor_list',
            'professor_add',
            'professor_edit',
            'consultation_list',
            'consultation_add',
            'consultation_edit',
          ].includes($route.name)
        "
      >
        <li
          :class="{
            active: [
              'members_admin',
              'member_admin_add',
              'member_admin_edit',
            ].includes($route.name),
          }"
        >
          <router-link
            :to="{ name: 'members_admin' }"
            data-toggle="accordion"
            data-target="#WIP"
            class="left_f_list no_arrow"
          >
            <img
              :src="`${baseUrl}assets/media/images/icon/new-menu-ic1-.png`"
              alt=""
              class="default"
            />
            <img
              :src="`${baseUrl}assets/media/images/icon/new-menu-ic1-active.png`"
              alt=""
              class="active"
            />
            <span>{{ $t('sidebar.adminMember.adminMember') }}</span>
          </router-link>
        </li>
        <li
          :class="{
            active: ['parent_list', 'parent_add', 'parent_edit'].includes(
              $route.name
            ),
          }"
        >
          <router-link
            :to="{ name: 'parent_list' }"
            data-toggle="accordion"
            data-target="#WIP"
            class="left_f_list no_arrow"
          >
            <img
              :src="`${baseUrl}assets/media/images/icon/new-menu-ic2.png`"
              alt=""
              class="default"
            />
            <img
              :src="`${baseUrl}assets/media/images/icon/new-menu-ic2-active.png`"
              alt=""
              class="active"
            />
            <span>{{ $t('sidebar.parentMember.parentMember') }}</span>
          </router-link>
        </li>
        <li
          :class="{
            active: ['student_list', 'student_add', 'student_edit'].includes(
              $route.name
            ),
          }"
        >
          <router-link
            :to="{ name: 'student_list' }"
            data-toggle="accordion"
            data-target="#WIP"
            class="left_f_list no_arrow"
          >
            <img
              :src="`${baseUrl}assets/media/images/icon/new-menu-ic3.png`"
              alt=""
              class="default"
            />
            <img
              :src="`${baseUrl}assets/media/images/icon/new-menu-ic3-active.png`"
              alt=""
              class="active"
            />
            <span>{{ $t('sidebar.studentMember.studentMember') }}</span>
          </router-link>
        </li>
        <li
          :class="{
            active: [
              'professor_list',
              'professor_add',
              'professor_edit',
            ].includes($route.name),
          }"
        >
          <router-link
            :to="{ name: 'professor_list' }"
            data-toggle="accordion"
            data-target="#WIP"
            class="left_f_list no_arrow"
          >
            <img
              :src="`${baseUrl}assets/media/images/icon/new-menu-ic4.png`"
              alt=""
              class="default"
            />
            <img
              :src="`${baseUrl}assets/media/images/icon/new-menu-ic4-active.png`"
              alt=""
              class="active"
            />
            <span>{{ $t('sidebar.professorMember.professorMember') }}</span>
          </router-link>
        </li>
        <li
          :class="{
            active: [
              'consultation_list',
              'consultation_add',
              'consultation_edit',
            ].includes($route.name),
          }"
        >
          <router-link
            :to="{ name: 'consultation_list' }"
            data-toggle="accordion"
            data-target="#WIP"
            class="left_f_list no_arrow"
          >
            <img
              :src="`${baseUrl}assets/media/images/icon/new-menu-ic4.png`"
              alt=""
              class="default"
            />
            <img
              :src="`${baseUrl}assets/media/images/icon/new-menu-ic4-active.png`"
              alt=""
              class="active"
            />
            <span>상담내역</span>
          </router-link>
        </li>
      </template>
      <template
        v-if="
          [
            'lecture_course_learning_list',
            'lecture_course_learning_add',
            'lecture_course_learning_edit',
            'thinking_skill_list',
            'thinking_skill_top_solution_add',
            'thinking_skill_top_solution_edit',
            'thinking_skill_add',
            'thinking_skill_thinking_ability_add',
            'thinking_skill_thinking_ability_edit',
            'thinking_skill_examination_add',
            'thinking_skill_edit',
            'thinking_skill_examination_edit',
            'holiday_systematic_mathematics_list',
            'holiday_systematic_mathematics_add',
            'holiday_systematic_mathematics_edit',
            'holiday_parochial_mathematics_list',
            'holiday_parochial_mathematics_add',
            'holiday_parochial_mathematics_edit',
            'holiday_convergence_mathematics_list',
            'holiday_convergence_mathematics_add',
            'holiday_convergence_mathematics_edit',
            'holiday_parent_special_lecture_list',
            'holiday_parent_special_lecture_add',
            'holiday_parent_special_lecture_edit',
            'holiday_enjoy_learning_list',
            'holiday_enjoy_learning_add',
            'holiday_enjoy_learning_edit',
            'special_lecture_list',
            'special_lecture_create',
            'special_lecture_edit',
            'lecture_video_list',
            'question_video_list',
          ].includes($route.name)
        "
      >
        <li
          :class="{
            active: [
              'lecture_course_learning_list',
              'lecture_course_learning_add',
              'lecture_course_learning_edit',
            ].includes($route.name),
          }"
        >
          <router-link
            :to="{ name: 'lecture_course_learning_list' }"
            data-toggle="accordion"
            data-target="#WIP"
            class="left_f_list no_arrow"
          >
            <img
              :src="`${baseUrl}assets/media/images/icon/new-menu-ic1-.png`"
              alt=""
              class="default"
            />
            <img
              :src="`${baseUrl}assets/media/images/icon/new-menu-ic1-active.png`"
              alt=""
              class="active"
            />
            <span>{{ $t('sidebar.courseLearning.courseLearning') }}</span>
          </router-link>
        </li>
        <li
          :class="{
            active: [
              'thinking_skill_list',
              'thinking_skill_top_solution_add',
              'thinking_skill_top_solution_edit',
              'thinking_skill_thinking_ability_add',
              'thinking_skill_thinking_ability_edit',
              'thinking_skill_examination_add',
              'thinking_skill_examination_edit',
            ].includes($route.name),
          }"
        >
          <router-link
            :to="{ name: 'thinking_skill_list' }"
            data-toggle="accordion"
            data-target="#WIP"
            class="left_f_list no_arrow"
          >
            <img
              :src="`${baseUrl}assets/media/images/icon/new-menu-ic2.png`"
              alt=""
              class="default"
            />
            <img
              :src="`${baseUrl}assets/media/images/icon/new-menu-ic2-active.png`"
              alt=""
              class="active"
            />
            <span>{{ $t('sidebar.thinkingSkill.thinkingSkill') }}</span>
          </router-link>
        </li>

        <!-- <li :class="{'active': ['lecture_holiday_lecture_list', 'holiday_lecture_core_summary_add', 'holiday_lecture_core_summary_edit',
                    'holiday_lecture_narrative_add', 'holiday_lecture_narrative_edit', 'holiday_lecture_parents_lecture_add', 'holiday_lecture_parents_lecture_edit'].includes($route.name)}">
                    <router-link :to="{name: 'lecture_holiday_lecture_list'}" data-toggle="accordion" data-target="#WIP" class="left_f_list  no_arrow">
                        <img :src="`${baseUrl}assets/media/images/icon/new-menu-ic3.png`" alt="" class="default">
                        <img :src="`${baseUrl}assets/media/images/icon/new-menu-ic3-active.png`" alt="" class="active">
                        <span>{{ $t('sidebar.holidayLecture.holidayLecture') }}</span>
                    </router-link>
                </li> -->

        <!-- <li :class="{'active': (['holiday_systematic_mathematics_list', 'holiday_systematic_mathematics_add', 'holiday_systematic_mathematics_edit',
                    'holiday_parochial_mathematics_list','holiday_parochial_mathematics_add', 'holiday_parochial_mathematics_edit',
                    'holiday_convergence_mathematics_list', 'holiday_convergence_mathematics_add', 'holiday_convergence_mathematics_edit',
                    'holiday_parent_special_lecture_list', 'holiday_parent_special_lecture_add', 'holiday_parent_special_lecture_edit',
                    'holiday_enjoy_learning_list', 'holiday_enjoy_learning_add', 'holiday_enjoy_learning_edit'].includes($route.name))}">

                    <div data-toggle="accordion" data-target="#attribute" class="left_f_list" :class="{'open': (['holiday_systematic_mathematics_list', 
                        'holiday_systematic_mathematics_add', 'holiday_systematic_mathematics_edit',
                        'holiday_parochial_mathematics_list','holiday_parochial_mathematics_add', 'holiday_parochial_mathematics_edit',
                        'holiday_convergence_mathematics_list', 'holiday_convergence_mathematics_add', 'holiday_convergence_mathematics_edit',
                        'holiday_parent_special_lecture_list', 'holiday_parent_special_lecture_add', 'holiday_parent_special_lecture_edit',
                        'holiday_enjoy_learning_list', 'holiday_enjoy_learning_add', 'holiday_enjoy_learning_edit'].includes($route.name))}">
                        <a role="button">
                            <img :src="`${baseUrl}assets/media/images/icon/new-menu-ic3.png`" alt="" class="default">
                            <img :src="`${baseUrl}assets/media/images/icon/new-menu-ic3-active.png`" alt="" class="active">
                            <span>{{ $t('sidebar.holidayLecture.holidayLecture') }}</span>
                        </a> 
                    </div>

                    <ul class="sub_accordion first_level" id="attribute" :class="{'current': (['holiday_systematic_mathematics_list', 
                        'holiday_systematic_mathematics_add', 'holiday_systematic_mathematics_edit',
                        'holiday_parochial_mathematics_list','holiday_parochial_mathematics_add', 'holiday_parochial_mathematics_edit',
                        'holiday_convergence_mathematics_list', 'holiday_convergence_mathematics_add', 'holiday_convergence_mathematics_edit',
                        'holiday_parent_special_lecture_list', 'holiday_parent_special_lecture_add', 'holiday_parent_special_lecture_edit',
                        'holiday_enjoy_learning_list', 'holiday_enjoy_learning_add', 'holiday_enjoy_learning_edit'].includes($route.name))}" 
                        style="display:block">

                        <li :class="{'active': ['holiday_systematic_mathematics_list', 'holiday_systematic_mathematics_add', 'holiday_systematic_mathematics_edit'].includes($route.name)}">
                            <router-link :to="{name: 'holiday_systematic_mathematics_list'}" data-toggle="accordion" data-target="#WIP" class="sub_menu no_arrow">
                                <img :src="`${baseUrl}assets/media/images/icon/new-menu-ic4.png`" alt="" class="default">
                                <img :src="`${baseUrl}assets/media/images/icon/new-menu-ic4-active.png`" alt="" class="active">
                                <span>{{ $t('sidebar.holidayLecture.systematic_mathematics') }}</span>
                            </router-link>
                        </li>
                        <li :class="{'active': ['holiday_parochial_mathematics_list', 'holiday_parochial_mathematics_add', 'holiday_parochial_mathematics_edit'].includes($route.name)}">
                            <router-link :to="{name: 'holiday_parochial_mathematics_list'}" data-toggle="accordion" data-target="#WIP" class="sub_menu no_arrow">
                                <img :src="`${baseUrl}assets/media/images/icon/new-menu-ic4.png`" alt="" class="default">
                                <img :src="`${baseUrl}assets/media/images/icon/new-menu-ic4-active.png`" alt="" class="active">
                                <span>{{ $t('sidebar.holidayLecture.parochial_mathematics') }}</span>
                            </router-link>
                        </li>
                        <li :class="{'active': ['holiday_convergence_mathematics_list', 'holiday_convergence_mathematics_add', 'holiday_convergence_mathematics_edit'].includes($route.name)}">
                            <router-link :to="{name: 'holiday_convergence_mathematics_list'}" data-toggle="accordion" data-target="#WIP" class="sub_menu no_arrow">
                                <img :src="`${baseUrl}assets/media/images/icon/new-menu-ic4.png`" alt="" class="default">
                                <img :src="`${baseUrl}assets/media/images/icon/new-menu-ic4-active.png`" alt="" class="active">
                                <span>{{ $t('sidebar.holidayLecture.convergence_mathematics') }}</span>
                            </router-link>
                        </li>
                        <li :class="{'active': ['holiday_parent_special_lecture_list', 'holiday_parent_special_lecture_add', 'holiday_parent_special_lecture_edit'].includes($route.name)}">
                            <router-link :to="{name: 'holiday_parent_special_lecture_list'}" data-toggle="accordion" data-target="#WIP" class="sub_menu no_arrow">
                                <img :src="`${baseUrl}assets/media/images/icon/new-menu-ic4.png`" alt="" class="default">
                                <img :src="`${baseUrl}assets/media/images/icon/new-menu-ic4-active.png`" alt="" class="active">
                                <span>{{ $t('sidebar.holidayLecture.parent_special_lecture') }}</span>
                            </router-link>
                        </li>
                        <li :class="{'active': ['holiday_enjoy_learning_list', 'holiday_enjoy_learning_add', 'holiday_enjoy_learning_edit'].includes($route.name)}">
                            <router-link :to="{name: 'holiday_enjoy_learning_list'}" data-toggle="accordion" data-target="#WIP" class="sub_menu no_arrow">
                                <img :src="`${baseUrl}assets/media/images/icon/new-menu-ic4.png`" alt="" class="default">
                                <img :src="`${baseUrl}assets/media/images/icon/new-menu-ic4-active.png`" alt="" class="active">
                                <span>{{ $t('sidebar.holidayLecture.enjoy_learning') }}</span>
                            </router-link>
                        </li>
                    </ul>
                </li> -->
        <li>
          <div class="left_f_list open">
            <a role="button">
              <img
                :src="`${baseUrl}assets/media/images/icon/new-menu-ic3.png`"
                alt=""
                class="default"
              />
              <img
                :src="`${baseUrl}assets/media/images/icon/new-menu-ic3-active.png`"
                alt=""
                class="active"
              />
              <span>{{ $t('sidebar.holidayLecture.holidayLecture') }}</span>
            </a>
            <span @click.prevent="openSlCategoryModal()"
              ><i class="lni lni-plus"></i
            ></span>
          </div>

          <ul
            class="sub_accordion first_level"
            style="display: block"
            v-if="specialLectureCategories.length > 0"
          >
            <li
              v-for="(
                specialLectureCategory, index
              ) in specialLectureCategories"
              :key="'specialLectureCategory_' + index"
              :class="{
                active: [
                  'special_lecture_list',
                  'special_lecture_create',
                  'special_lecture_edit',
                ].includes($route.name),
              }"
            >
              <router-link
                :to="{
                  name: 'special_lecture_list',
                  params: { id: specialLectureCategory.id },
                }"
                data-toggle="accordion"
                data-target="#WIP"
                class="sub_menu no_arrow"
              >
                <img
                  :src="`${baseUrl}assets/media/images/icon/new-menu-ic4.png`"
                  alt=""
                  class="default"
                />
                <img
                  :src="`${baseUrl}assets/media/images/icon/new-menu-ic4-active.png`"
                  alt=""
                  class="active"
                />
                <span>{{ specialLectureCategory.name }}</span>
              </router-link>
            </li>
          </ul>
        </li>
        <li
          :class="{
            active: ['lecture_video_list', 'question_video_list'].includes(
              $route.name
            ),
          }"
        >
          <div
            data-toggle="accordion"
            data-target="#faq"
            class="left_f_list"
            :class="{ open: ['lecture_video_list', 'question_video_list'] }"
          >
            <a role="button">
              <img
                :src="`${baseUrl}assets/media/images/icon/new-menu-ic4.png`"
                alt=""
                class="default"
              />
              <img
                :src="`${baseUrl}assets/media/images/icon/new-menu-ic4-active.png`"
                alt=""
                class="active"
              />
              <span>비디오 변환 목록</span>
            </a>
          </div>
          <ul
            class="sub_accordion first_level"
            id="faq"
            :class="{ current: ['lecture_video_list', 'question_video_list'] }"
          >
            <li
              :class="{ active: ['lecture_video_list'].includes($route.name) }"
            >
              <router-link
                :to="{ name: 'lecture_video_list' }"
                data-toggle="accordion"
                data-target="#WIP"
                class="sub_menu no_arrow"
              >
                <img
                  :src="`${baseUrl}assets/media/images/icon/new-menu-ic4.png`"
                  alt=""
                  class="default"
                />
                <img
                  :src="`${baseUrl}assets/media/images/icon/new-menu-ic4-active.png`"
                  alt=""
                  class="active"
                />
                <span>강의영상</span>
              </router-link>
            </li>
            <li
              :class="{ active: ['question_video_list'].includes($route.name) }"
            >
              <router-link
                :to="{ name: 'question_video_list' }"
                data-toggle="accordion"
                data-target="#WIP"
                class="sub_menu no_arrow"
              >
                <img
                  :src="`${baseUrl}assets/media/images/icon/new-menu-ic4.png`"
                  alt=""
                  class="default"
                />
                <img
                  :src="`${baseUrl}assets/media/images/icon/new-menu-ic4-active.png`"
                  alt=""
                  class="active"
                />
                <span>질문 영상</span>
              </router-link>
            </li>
          </ul>
        </li>
      </template>
      <template
        v-if="
          [
            'package_list',
            'package_add',
            'package_edit',
            'product_list',
            'product_add',
            'product_edit',
          ].includes($route.name)
        "
      >
        <li
          :class="{
            active: ['package_list', 'package_add', 'package_edit'].includes(
              $route.name
            ),
          }"
        >
          <router-link
            :to="{ name: 'package_list' }"
            data-toggle="accordion"
            data-target="#WIP"
            class="left_f_list no_arrow"
          >
            <img
              :src="`${baseUrl}assets/media/images/icon/new-menu-ic1-.png`"
              alt=""
              class="default"
            />
            <img
              :src="`${baseUrl}assets/media/images/icon/new-menu-ic1-active.png`"
              alt=""
              class="active"
            />
            <span>{{ $t('sidebar.packageManagement.packageManagement') }}</span>
          </router-link>
        </li>
        <li
          :class="{
            active: ['product_list', 'product_add', 'product_edit'].includes(
              $route.name
            ),
          }"
        >
          <router-link
            :to="{ name: 'product_list' }"
            data-toggle="accordion"
            data-target="#WIP"
            class="left_f_list no_arrow"
          >
            <img
              :src="`${baseUrl}assets/media/images/icon/new-menu-ic1-.png`"
              alt=""
              class="default"
            />
            <img
              :src="`${baseUrl}assets/media/images/icon/new-menu-ic1-active.png`"
              alt=""
              class="active"
            />
            <span>{{ $t('sidebar.products.products') }}</span>
          </router-link>
        </li>
      </template>
      <template
        v-if="
          ['product_list', 'product_add', 'product_edit'].includes($route.name)
        "
      >
      </template>

      <template
        v-if="
          [
            'orders',
            'order_edit',
            'settings_promotion',
            'settings_promotion_add',
            'settings_promotion_edit',
          ].includes($route.name)
        "
      >
        <li :class="{ active: ['orders', 'order_edit'].includes($route.name) }">
          <router-link
            :to="{ name: 'orders' }"
            data-toggle="accordion"
            data-target="#WIP"
            class="left_f_list no_arrow"
          >
            <img
              :src="`${baseUrl}assets/media/images/icon/new-menu-ic1-.png`"
              alt=""
              class="default"
            />
            <img
              :src="`${baseUrl}assets/media/images/icon/new-menu-ic1-active.png`"
              alt=""
              class="active"
            />
            <span>{{ $t('sidebar.orderManagement.orderManagement') }}</span>
          </router-link>
        </li>
        <li
          :class="{
            active: [
              'settings_promotion',
              'settings_promotion_add',
              'settings_promotion_edit',
            ].includes($route.name),
          }"
        >
          <router-link
            :to="{ name: 'settings_promotion' }"
            data-toggle="accordion"
            data-target="#WIP"
            class="left_f_list no_arrow"
          >
            <img
              :src="`${baseUrl}assets/media/images/icon/new-menu-ic4.png`"
              alt=""
              class="default"
            />
            <img
              :src="`${baseUrl}assets/media/images/icon/new-menu-ic4-active.png`"
              alt=""
              class="active"
            />
            <span>{{ $t('sidebar.promotion.promotion') }}</span>
          </router-link>
        </li>
      </template>
      <template
        v-if="
          [
            'exam_questions',
            'exam_questions_add',
            'exam_questions_edit',
            'exam_management_exams',
            'exam_management_exam_add',
            'exam_management_exam_edit',
          ].includes($route.name)
        "
      >
        <li
          :class="{
            active: [
              'exam_questions',
              'exam_questions_add',
              'exam_questions_edit',
            ].includes($route.name),
          }"
        >
          <router-link
            :to="{ name: 'exam_questions' }"
            data-toggle="accordion"
            data-target="#WIP"
            class="left_f_list no_arrow"
          >
            <img
              :src="`${baseUrl}assets/media/images/icon/new-menu-ic1-.png`"
              alt=""
              class="default"
            />
            <img
              :src="`${baseUrl}assets/media/images/icon/new-menu-ic1-active.png`"
              alt=""
              class="active"
            />
            <span>{{ $t('sidebar.questions.questions') }}</span>
          </router-link>
        </li>
        <li
          :class="{
            active: [
              'exam_management_exams',
              'exam_management_exam_add',
              'exam_management_exam_edit',
            ].includes($route.name),
          }"
        >
          <router-link
            :to="{ name: 'exam_management_exams' }"
            data-toggle="accordion"
            data-target="#WIP"
            class="left_f_list no_arrow"
          >
            <img
              :src="`${baseUrl}assets/media/images/icon/new-menu-ic1-.png`"
              alt=""
              class="default"
            />
            <img
              :src="`${baseUrl}assets/media/images/icon/new-menu-ic1-active.png`"
              alt=""
              class="active"
            />
            <span>{{ $t('sidebar.exams.exams') }}</span>
          </router-link>
        </li>
      </template>

      <template
        v-if="
          [
            'settings_lecture_category',
            'settings_lecture_category_add',
            'settings_lecture_category_edit',
            'settings_subject',
            'settings_subject_add',
            'settings_subject_edit',
            'settings_area',
            'settings_area_add',
            'settings_area_edit',
            'settings_thinking_area',
            'settings_thinking_area_add',
            'settings_thinking_area_edit',
            'settings_portion',
            'settings_portion_add',
            'settings_portion_edit',
            'settings_grade',
            'settings_grade_add',
            'settings_grade_edit',
            'settings_semesters',
            'settings_semester_add',
            'settings_semester_edit',
            'settings_week',
            'settings_week_add',
            'settings_week_edit',
            'settings_textbook_list',
            'settings_textbook_add',
            'settings_textbook_edit',
            'settings_connection_services',
            'settings_connection_service_add',
            'settings_connection_service_edit',
            'settings_chapter',
            'settings_chapter_add',
            'settings_chapter_edit',
            'settings_parkings',
            'settings_parking_add',
            'settings_parking_edit',
            'settings_difficulty',
            'settings_difficulty_add',
            'settings_difficulty_edit',
            'settings_point',
            'settings_point_add',
            'settings_point_edit',
            'settings_exam_type',
            'settings_exam_type_add',
            'settings_exam_type_edit',
            'settings_question_type',
            'settings_question_type_add',
            'settings_question_type_edit',
            'settings_folder_unit',
            'settings_folder_unit_add',
            'settings_folder_unit_edit',
            'settings_folder_grade',
            'settings_folder_grade_add',
            'settings_folder_grade_edit',
            'settings_folder_semester',
            'settings_folder_semester_add',
            'settings_folder_semester_edit',
            'home_banner',
            'notice_list',
            'notice_add',
            'notice_edit',
            'faq_list',
            'faq_add',
            'faq_edit',
            'faq_category_list',
            'faq_category_add',
            'faq_category_edit',
            'magazine_slider_list',
            'magazine_slider_add',
            'magazine_slider_edit',
            'unit_registration_list',
            'unit_registration_add',
            'unit_registration_edit',
            'test_lecture_list',
            'test_lecture_add',
            'test_lecture_edit',
            'home_banner_add',
            'home_banner_edit',
            'download_list',
            'download_add',
            'download_edit',
            'grade_group',
            'grade_group_add',
            'grade_group_edit',
            'inquiry_type_list',
            'inquiry_type_add',
            'inquiry_type_edit',
            'seo_manage_index',
            'seo_manage_create',
            'seo_manage_edit',
            'landing_page_list',
            'landing_page_add',
            'landing_page_edit',
          ].includes($route.name)
        "
      >
        <li
          :class="{
            active: [
              'home_banner',
              'home_banner_add',
              'home_banner_edit',
            ].includes($route.name),
          }"
        >
          <router-link
            :to="{ name: 'home_banner' }"
            data-toggle="accordion"
            data-target="#WIP"
            class="left_f_list no_arrow"
          >
            <img
              :src="`${baseUrl}assets/media/images/icon/new-menu-ic4.png`"
              alt=""
              class="default"
            />
            <img
              :src="`${baseUrl}assets/media/images/icon/new-menu-ic4-active.png`"
              alt=""
              class="active"
            />
            <span>{{ $t('sidebar.home_banner.home_banner') }}</span>
          </router-link>
        </li>
        <li
          :class="{
            active: [
              'test_lecture_list',
              'test_lecture_add',
              'test_lecture_edit',
            ].includes($route.name),
          }"
        >
          <router-link
            :to="{ name: 'test_lecture_list' }"
            data-toggle="accordion"
            data-target="#WIP"
            class="left_f_list no_arrow"
          >
            <img
              :src="`${baseUrl}assets/media/images/icon/new-menu-ic4.png`"
              alt=""
              class="default"
            />
            <img
              :src="`${baseUrl}assets/media/images/icon/new-menu-ic4-active.png`"
              alt=""
              class="active"
            />
            <span>맛보기 강의</span>
          </router-link>
        </li>
        <li
          :class="{
            active: ['download_list', 'download_add', 'download_edit'].includes(
              $route.name
            ),
          }"
        >
          <router-link
            :to="{ name: 'download_list' }"
            data-toggle="accordion"
            data-target="#WIP"
            class="left_f_list no_arrow"
          >
            <img
              :src="`${baseUrl}assets/media/images/icon/new-menu-ic4.png`"
              alt=""
              class="default"
            />
            <img
              :src="`${baseUrl}assets/media/images/icon/new-menu-ic4-active.png`"
              alt=""
              class="active"
            />
            <span>{{ $t('sidebar.fileDownload.download') }}</span>
          </router-link>
        </li>
        <li
          :class="{
            active: ['notice_list', 'notice_add', 'notice_edit'].includes(
              $route.name
            ),
          }"
        >
          <router-link
            :to="{ name: 'notice_list' }"
            data-toggle="accordion"
            data-target="#WIP"
            class="left_f_list no_arrow"
          >
            <img
              :src="`${baseUrl}assets/media/images/icon/new-menu-ic4.png`"
              alt=""
              class="default"
            />
            <img
              :src="`${baseUrl}assets/media/images/icon/new-menu-ic4-active.png`"
              alt=""
              class="active"
            />
            <span>{{ $t('sidebar.notice.notice') }}</span>
          </router-link>
        </li>
        <li
          :class="{
            active: [
              'faq_list',
              'faq_add',
              'faq_edit',
              'faq_category_list',
              'faq_category_add',
              'faq_category_edit',
            ].includes($route.name),
          }"
        >
          <div
            data-toggle="accordion"
            data-target="#faq"
            class="left_f_list"
            :class="{
              open: [
                'faq_list',
                'faq_add',
                'faq_edit',
                'faq_category_list',
                'faq_category_add',
                'faq_category_edit',
                'inquiry_type_list',
                'inquiry_type_add',
                'inquiry_type_edit',
              ],
            }"
          >
            <a role="button">
              <img
                :src="`${baseUrl}assets/media/images/icon/new-menu-ic4.png`"
                alt=""
                class="default"
              />
              <img
                :src="`${baseUrl}assets/media/images/icon/new-menu-ic4-active.png`"
                alt=""
                class="active"
              />
              <span>{{ $t('sidebar.faq.faq') }}</span>
            </a>
          </div>
          <ul
            class="sub_accordion first_level"
            id="faq"
            :class="{
              current: [
                'faq_list',
                'faq_add',
                'faq_edit',
                'faq_category_list',
                'faq_category_add',
                'faq_category_edit',
                'inquiry_type_list',
                'inquiry_type_add',
                'inquiry_type_edit',
              ],
            }"
          >
            <li
              :class="{
                active: ['faq_list', 'faq_add', 'faq_edit'].includes(
                  $route.name
                ),
              }"
            >
              <router-link
                :to="{ name: 'faq_list' }"
                data-toggle="accordion"
                data-target="#WIP"
                class="sub_menu no_arrow"
              >
                <img
                  :src="`${baseUrl}assets/media/images/icon/new-menu-ic4.png`"
                  alt=""
                  class="default"
                />
                <img
                  :src="`${baseUrl}assets/media/images/icon/new-menu-ic4-active.png`"
                  alt=""
                  class="active"
                />
                <span>{{ $t('sidebar.faq.faq') }}</span>
              </router-link>
            </li>
            <li
              :class="{
                active: [
                  'faq_category_list',
                  'faq_category_add',
                  'faq_category_edit',
                ].includes($route.name),
              }"
            >
              <router-link
                :to="{ name: 'faq_category_list' }"
                data-toggle="accordion"
                data-target="#WIP"
                class="sub_menu no_arrow"
              >
                <img
                  :src="`${baseUrl}assets/media/images/icon/new-menu-ic4.png`"
                  alt=""
                  class="default"
                />
                <img
                  :src="`${baseUrl}assets/media/images/icon/new-menu-ic4-active.png`"
                  alt=""
                  class="active"
                />
                <span>{{ $t('sidebar.faq_category.faq_category') }}</span>
              </router-link>
            </li>
            <li
              :class="{
                active: [
                  ,
                  'inquiry_type_list',
                  'inquiry_type_add',
                  'inquiry_type_edit',
                ].includes($route.name),
              }"
            >
              <router-link
                :to="{ name: 'inquiry_type_list' }"
                data-toggle="accordion"
                data-target="#WIP"
                class="sub_menu no_arrow"
              >
                <img
                  :src="`${baseUrl}assets/media/images/icon/new-menu-ic4.png`"
                  alt=""
                  class="default"
                />
                <img
                  :src="`${baseUrl}assets/media/images/icon/new-menu-ic4-active.png`"
                  alt=""
                  class="active"
                />
                <span>문의종류관리</span>
              </router-link>
            </li>
          </ul>
        </li>
        <li
          :class="{
            active: [
              'magazine_slider_list',
              'magazine_slider_add',
              'magazine_slider_edit',
            ].includes($route.name),
          }"
        >
          <router-link
            :to="{ name: 'magazine_slider_list' }"
            data-toggle="accordion"
            data-target="#WIP"
            class="left_f_list no_arrow"
          >
            <img
              :src="`${baseUrl}assets/media/images/icon/new-menu-ic4.png`"
              alt=""
              class="default"
            />
            <img
              :src="`${baseUrl}assets/media/images/icon/new-menu-ic4-active.png`"
              alt=""
              class="active"
            />
            <span>{{ $t('sidebar.magazine_slider.magazine_slider') }}</span>
          </router-link>
        </li>

        <li
          :class="{
            active: [
              'settings_lecture_category',
              'settings_lecture_category_add',
              'settings_lecture_category_edit',
              'settings_subject',
              'settings_subject_add',
              'settings_subject_edit',
              'settings_area',
              'settings_area_add',
              'settings_area_edit',
              'settings_thinking_area',
              'settings_thinking_area_add',
              'settings_thinking_area_edit',
              'settings_portion',
              'settings_portion_add',
              'settings_portion_edit',
              'settings_grade',
              'settings_grade_add',
              'settings_grade_edit',
              'settings_semesters',
              'settings_semester_add',
              'settings_semester_edit',
              'settings_week',
              'settings_week_add',
              'settings_week_edit',
              'settings_textbook_list',
              'settings_textbook_add',
              'settings_textbook_edit',
              'settings_connection_services',
              'settings_connection_service_add',
              'settings_connection_service_edit',
              'settings_chapter',
              'settings_chapter_add',
              'settings_chapter_edit',
              'settings_parkings',
              'settings_parking_add',
              'settings_parking_edit',
              'settings_difficulty',
              'settings_difficulty_add',
              'settings_difficulty_edit',
              'settings_point',
              'settings_point_add',
              'settings_point_edit',
              'settings_exam_type',
              'settings_exam_type_add',
              'settings_exam_type_edit',
              'settings_question_type',
              'settings_question_type_add',
              'settings_question_type_edit',
              'settings_folder_unit',
              'settings_folder_unit_add',
              'settings_folder_unit_edit',
              'settings_folder_grade',
              'settings_folder_grade_add',
              'settings_folder_grade_edit',
              'settings_folder_semester',
              'settings_folder_semester_add',
              'settings_folder_semester_edit',
              'unit_registration_list',
              'unit_registration_add',
              'unit_registration_edit',
              'grade_group',
              'grade_group_add',
              'grade_group_edit',
            ].includes($route.name),
          }"
        >
          <div
            data-toggle="accordion"
            data-target="#attribute"
            class="left_f_list"
            :class="{
              open: [
                'settings_lecture_category',
                'settings_lecture_category_add',
                'settings_lecture_category_edit',
                'settings_subject',
                'settings_subject_add',
                'settings_subject_edit',
                'settings_area',
                'settings_area_add',
                'settings_area_edit',
                'settings_thinking_area',
                'settings_thinking_area_add',
                'settings_thinking_area_edit',
                'settings_portion',
                'settings_portion_add',
                'settings_portion_edit',
                'settings_grade',
                'settings_grade_add',
                'settings_grade_edit',
                'settings_semesters',
                'settings_semester_add',
                'settings_semester_edit',
                'settings_week',
                'settings_week_add',
                'settings_week_edit',
                'settings_textbook_list',
                'settings_textbook_add',
                'settings_textbook_edit',
                'settings_connection_services',
                'settings_connection_service_add',
                'settings_connection_service_edit',
                'settings_chapter',
                'settings_chapter_add',
                'settings_chapter_edit',
                'settings_parkings',
                'settings_parking_add',
                'settings_parking_edit',
                'settings_difficulty',
                'settings_difficulty_add',
                'settings_difficulty_edit',
                'settings_point',
                'settings_point_add',
                'settings_point_edit',
                'settings_exam_type',
                'settings_exam_type_add',
                'settings_exam_type_edit',
                'settings_question_type',
                'settings_question_type_add',
                'settings_question_type_edit',
                'settings_folder_unit',
                'settings_folder_unit_add',
                'settings_folder_unit_edit',
                'settings_folder_grade',
                'settings_folder_grade_add',
                'settings_folder_grade_edit',
                'settings_folder_semester',
                'settings_folder_semester_add',
                'settings_folder_semester_edit',
                'unit_registration_list',
                'unit_registration_add',
                'unit_registration_edit',
                'grade_group',
                'grade_group_add',
                'grade_group_edit',
              ].includes($route.name),
            }"
          >
            <a role="button">
              <img
                :src="`${baseUrl}assets/media/images/icon/7.png`"
                alt=""
                class="default"
              />
              <img
                :src="`${baseUrl}assets/media/images/icon/7.1.png`"
                alt=""
                class="active"
              />
              <span>{{ $t('common.attribute') }}</span>
            </a>
          </div>
          <ul
            class="sub_accordion first_level"
            id="attribute"
            :class="{
              current: [
                'settings_lecture_category',
                'settings_lecture_category_add',
                'settings_lecture_category_edit',
                'settings_subject',
                'settings_subject_add',
                'settings_subject_edit',
                'settings_area',
                'settings_area_add',
                'settings_area_edit',
                'settings_thinking_area',
                'settings_thinking_area_add',
                'settings_thinking_area_edit',
                'settings_portion',
                'settings_portion_add',
                'settings_portion_edit',
                'settings_grade',
                'settings_grade_add',
                'settings_grade_edit',
                'settings_semesters',
                'settings_semester_add',
                'settings_semester_edit',
                'settings_week',
                'settings_week_add',
                'settings_week_edit',
                'settings_textbook_list',
                'settings_textbook_add',
                'settings_textbook_edit',
                'settings_connection_services',
                'settings_connection_service_add',
                'settings_connection_service_edit',
                'settings_chapter',
                'settings_chapter_add',
                'settings_chapter_edit',
                'settings_parkings',
                'settings_parking_add',
                'settings_parking_edit',
                'settings_difficulty',
                'settings_difficulty_add',
                'settings_difficulty_edit',
                'settings_point',
                'settings_point_add',
                'settings_point_edit',
                'settings_exam_type',
                'settings_exam_type_add',
                'settings_exam_type_edit',
                'settings_question_type',
                'settings_question_type_add',
                'settings_question_type_edit',
                'settings_folder_unit',
                'settings_folder_unit_add',
                'settings_folder_unit_edit',
                'settings_folder_grade',
                'settings_folder_grade_add',
                'settings_folder_grade_edit',
                'settings_folder_semester',
                'settings_folder_semester_add',
                'settings_folder_semester_edit',
                'unit_registration_list',
                'unit_registration_add',
                'unit_registration_edit',
                'home_banner_add',
                'home_banner_edit',
                'grade_group',
                'grade_group_add',
                'grade_group_edit',
              ].includes($route.name),
            }"
            style="display: block"
          >
            <!-- <li :class="{'active': ['settings_lecture_category','settings_lecture_category_add','settings_lecture_category_edit'].includes($route.name)}">
                                <div data-toggle="accordion" data-target="#WIP" class="left_f_list  no_arrow">
                                    <router-link :to="{name: 'settings_lecture_category'}" >
                                        <img :src="`${baseUrl}assets/media/images/icon/new-menu-ic4.png`" alt="" class="default">
                                        <img :src="`${baseUrl}assets/media/images/icon/new-menu-ic4-active.png`" alt="" class="active">
                                        <span>{{ $t('sidebar.lecture_category.lecture_category') }}</span>
                                    </router-link>
                                </div>
                            </li> -->
            <li
              :class="{
                active: [
                  'settings_subject',
                  'settings_subject_add',
                  'settings_subject_edit',
                ].includes($route.name),
              }"
            >
              <router-link
                :to="{ name: 'settings_subject' }"
                data-toggle="accordion"
                data-target="#WIP"
                class="sub_menu no_arrow"
              >
                <img
                  :src="`${baseUrl}assets/media/images/icon/new-menu-ic4.png`"
                  alt=""
                  class="default"
                />
                <img
                  :src="`${baseUrl}assets/media/images/icon/new-menu-ic4-active.png`"
                  alt=""
                  class="active"
                />
                <span>{{ $t('sidebar.subjects.subjects') }}</span>
              </router-link>
            </li>
            <li
              :class="{
                active: [
                  'settings_question_type',
                  'settings_question_type_add',
                  'settings_question_type_edit',
                ].includes($route.name),
              }"
            >
              <router-link
                :to="{ name: 'settings_question_type' }"
                data-toggle="accordion"
                data-target="#WIP"
                class="sub_menu no_arrow"
              >
                <img
                  :src="`${baseUrl}assets/media/images/icon/new-menu-ic4.png`"
                  alt=""
                  class="default"
                />
                <img
                  :src="`${baseUrl}assets/media/images/icon/new-menu-ic4-active.png`"
                  alt=""
                  class="active"
                />
                <span>{{ $t('sidebar.question_types.question_types') }}</span>
              </router-link>
            </li>
            <li
              :class="{
                active: [
                  'settings_folder_grade',
                  'settings_folder_grade_add',
                  'settings_folder_grade_edit',
                ].includes($route.name),
              }"
            >
              <router-link
                :to="{ name: 'settings_folder_grade' }"
                data-toggle="accordion"
                data-target="#WIP"
                class="sub_menu no_arrow"
              >
                <img
                  :src="`${baseUrl}assets/media/images/icon/new-menu-ic4.png`"
                  alt=""
                  class="default"
                />
                <img
                  :src="`${baseUrl}assets/media/images/icon/new-menu-ic4-active.png`"
                  alt=""
                  class="active"
                />
                <span>{{ $t('sidebar.folder_grades.folder_grades') }}</span>
              </router-link>
            </li>
            <li
              :class="{
                active: [
                  'settings_folder_semester',
                  'settings_folder_semester_add',
                  'settings_folder_semester_edit',
                ].includes($route.name),
              }"
            >
              <router-link
                :to="{ name: 'settings_folder_semester' }"
                data-toggle="accordion"
                data-target="#WIP"
                class="sub_menu no_arrow"
              >
                <img
                  :src="`${baseUrl}assets/media/images/icon/new-menu-ic4.png`"
                  alt=""
                  class="default"
                />
                <img
                  :src="`${baseUrl}assets/media/images/icon/new-menu-ic4-active.png`"
                  alt=""
                  class="active"
                />
                <span>{{
                  $t('sidebar.folder_semesters.folder_semesters')
                }}</span>
              </router-link>
            </li>
            <li
              :class="{
                active: [
                  'settings_folder_unit',
                  'settings_folder_unit_add',
                  'settings_folder_unit_edit',
                ].includes($route.name),
              }"
            >
              <router-link
                :to="{ name: 'settings_folder_unit' }"
                data-toggle="accordion"
                data-target="#WIP"
                class="sub_menu no_arrow"
              >
                <img
                  :src="`${baseUrl}assets/media/images/icon/new-menu-ic4.png`"
                  alt=""
                  class="default"
                />
                <img
                  :src="`${baseUrl}assets/media/images/icon/new-menu-ic4-active.png`"
                  alt=""
                  class="active"
                />
                <span>{{ $t('sidebar.folder_units.folder_units') }}</span>
              </router-link>
            </li>
            <li
              :class="{
                active: [
                  'settings_area',
                  'settings_area_add',
                  'settings_area_edit',
                ].includes($route.name),
              }"
            >
              <router-link
                :to="{ name: 'settings_area' }"
                data-toggle="accordion"
                data-target="#WIP"
                class="sub_menu no_arrow"
              >
                <img
                  :src="`${baseUrl}assets/media/images/icon/new-menu-ic4.png`"
                  alt=""
                  class="default"
                />
                <img
                  :src="`${baseUrl}assets/media/images/icon/new-menu-ic4-active.png`"
                  alt=""
                  class="active"
                />
                <span>{{ $t('sidebar.areas.areas') }}</span>
              </router-link>
            </li>
            <li
              :class="{
                active: [
                  'settings_thinking_area',
                  'settings_thinking_area_add',
                  'settings_thinking_area_edit',
                ].includes($route.name),
              }"
            >
              <router-link
                :to="{ name: 'settings_thinking_area' }"
                data-toggle="accordion"
                data-target="#WIP"
                class="sub_menu no_arrow"
              >
                <img
                  :src="`${baseUrl}assets/media/images/icon/new-menu-ic4.png`"
                  alt=""
                  class="default"
                />
                <img
                  :src="`${baseUrl}assets/media/images/icon/new-menu-ic4-active.png`"
                  alt=""
                  class="active"
                />
                <span>{{ $t('sidebar.thinking_areas.thinking_areas') }}</span>
              </router-link>
            </li>
            <li
              :class="{
                active: [
                  'settings_portion',
                  'settings_portion_add',
                  'settings_portion_edit',
                ].includes($route.name),
              }"
            >
              <router-link
                :to="{ name: 'settings_portion' }"
                data-toggle="accordion"
                data-target="#WIP"
                class="sub_menu no_arrow"
              >
                <img
                  :src="`${baseUrl}assets/media/images/icon/new-menu-ic4.png`"
                  alt=""
                  class="default"
                />
                <img
                  :src="`${baseUrl}assets/media/images/icon/new-menu-ic4-active.png`"
                  alt=""
                  class="active"
                />
                <span>{{ $t('sidebar.portions.portions') }}</span>
              </router-link>
            </li>
            <li
              :class="{
                active: [
                  'settings_grade',
                  'settings_grade_add',
                  'settings_grade_edit',
                ].includes($route.name),
              }"
            >
              <router-link
                :to="{ name: 'settings_grade' }"
                data-toggle="accordion"
                data-target="#WIP"
                class="sub_menu no_arrow"
              >
                <img
                  :src="`${baseUrl}assets/media/images/icon/new-menu-ic4.png`"
                  alt=""
                  class="default"
                />
                <img
                  :src="`${baseUrl}assets/media/images/icon/new-menu-ic4-active.png`"
                  alt=""
                  class="active"
                />
                <span>{{ $t('common.grade') }}</span>
              </router-link>
            </li>
            <li
              :class="{
                active: [
                  'settings_semesters',
                  'settings_semester_add',
                  'settings_semester_edit',
                ].includes($route.name),
              }"
            >
              <router-link
                :to="{ name: 'settings_semesters' }"
                data-toggle="accordion"
                data-target="#WIP"
                class="sub_menu no_arrow"
              >
                <img
                  :src="`${baseUrl}assets/media/images/icon/new-menu-ic4.png`"
                  alt=""
                  class="default"
                />
                <img
                  :src="`${baseUrl}assets/media/images/icon/new-menu-ic4-active.png`"
                  alt=""
                  class="active"
                />
                <span>{{ $t('sidebar.semesters.semesters') }}</span>
              </router-link>
            </li>
            <li
              :class="{
                active: [
                  'grade_group',
                  'grade_group_add',
                  'grade_group_edit',
                ].includes($route.name),
              }"
            >
              <router-link
                :to="{ name: 'grade_group' }"
                data-toggle="accordion"
                data-target="#WIP"
                class="sub_menu no_arrow"
              >
                <img
                  :src="`${baseUrl}assets/media/images/icon/new-menu-ic4.png`"
                  alt=""
                  class="default"
                />
                <img
                  :src="`${baseUrl}assets/media/images/icon/new-menu-ic4-active.png`"
                  alt=""
                  class="active"
                />
                <span>{{ $t('special_lecture.grade_group.title') }}</span>
              </router-link>
            </li>
            <!-- <li :class="{'active': ['settings_week','settings_week_add','settings_week_edit'].includes($route.name)}">
                                <div data-toggle="accordion" data-target="#WIP" class="sub_menu  no_arrow">
                                    <router-link :to="{name: 'settings_week'}" >
                                        <img :src="`${baseUrl}assets/media/images/icon/new-menu-ic4.png`" alt="" class="default">
                                        <img :src="`${baseUrl}assets/media/images/icon/new-menu-ic4-active.png`" alt="" class="active">
                                        <span>{{ $t('common.week') }}</span>
                                    </router-link>
                                </div>
                            </li> -->
            <li
              :class="{
                active: [
                  'settings_chapter',
                  'settings_chapter_add',
                  'settings_chapter_edit',
                ].includes($route.name),
              }"
            >
              <router-link
                :to="{ name: 'settings_chapter' }"
                data-toggle="accordion"
                data-target="#WIP"
                class="sub_menu no_arrow"
              >
                <img
                  :src="`${baseUrl}assets/media/images/icon/new-menu-ic4.png`"
                  alt=""
                  class="default"
                />
                <img
                  :src="`${baseUrl}assets/media/images/icon/new-menu-ic4-active.png`"
                  alt=""
                  class="active"
                />
                <span>{{ $t('common.chapter') }}</span>
              </router-link>
            </li>
            <!-- <li :class="{'active': ['settings_connection_services','settings_connection_service_add','settings_connection_service_edit'].includes($route.name)}">
                                <div data-toggle="accordion" data-target="#WIP" class="sub_menu  no_arrow">
                                    <router-link :to="{name: 'settings_connection_services'}" >
                                        <img :src="`${baseUrl}assets/media/images/icon/new-menu-ic4.png`" alt="" class="default">
                                        <img :src="`${baseUrl}assets/media/images/icon/new-menu-ic4-active.png`" alt="" class="active">
                                        <span>{{ $t('connectionServices') }}</span>
                                    </router-link>
                                </div>
                            </li> -->
            <li
              :class="{
                active: [
                  'settings_difficulty',
                  'settings_difficulty_add',
                  'settings_difficulty_edit',
                ].includes($route.name),
              }"
            >
              <router-link
                :to="{ name: 'settings_difficulty' }"
                data-toggle="accordion"
                data-target="#WIP"
                class="sub_menu no_arrow"
              >
                <img
                  :src="`${baseUrl}assets/media/images/icon/new-menu-ic4.png`"
                  alt=""
                  class="default"
                />
                <img
                  :src="`${baseUrl}assets/media/images/icon/new-menu-ic4-active.png`"
                  alt=""
                  class="active"
                />
                <span>{{ $t('sidebar.difficulty.difficulty') }}</span>
              </router-link>
            </li>
            <li
              :class="{
                active: [
                  'settings_point',
                  'settings_point_add',
                  'settings_point_edit',
                ].includes($route.name),
              }"
            >
              <router-link
                :to="{ name: 'settings_point' }"
                data-toggle="accordion"
                data-target="#WIP"
                class="sub_menu no_arrow"
              >
                <img
                  :src="`${baseUrl}assets/media/images/icon/new-menu-ic4.png`"
                  alt=""
                  class="default"
                />
                <img
                  :src="`${baseUrl}assets/media/images/icon/new-menu-ic4-active.png`"
                  alt=""
                  class="active"
                />
                <span>{{ $t('sidebar.point.point') }}</span>
              </router-link>
            </li>
            <!-- <li :class="{'active': ['settings_exam_type','settings_exam_type_add','settings_exam_type_edit'].includes($route.name)}">
                                <div data-toggle="accordion" data-target="#WIP" class="sub_menu  no_arrow">
                                    <router-link :to="{name: 'settings_exam_type'}" >
                                        <img :src="`${baseUrl}assets/media/images/icon/new-menu-ic4.png`" alt="" class="default">
                                        <img :src="`${baseUrl}assets/media/images/icon/new-menu-ic4-active.png`" alt="" class="active">
                                        <span>{{ $t('sidebar.exam_type.exam_type') }}</span>
                                    </router-link>
                                </div>
                            </li> -->

            <li
              :class="{
                active: [
                  'settings_textbook_list',
                  'settings_textbook_add',
                  'settings_textbook_edit',
                ].includes($route.name),
              }"
            >
              <router-link
                :to="{ name: 'settings_textbook_list' }"
                data-toggle="accordion"
                data-target="#WIP"
                class="sub_menu no_arrow"
              >
                <img
                  :src="`${baseUrl}assets/media/images/icon/new-menu-ic4.png`"
                  alt=""
                  class="default"
                />
                <img
                  :src="`${baseUrl}assets/media/images/icon/new-menu-ic4-active.png`"
                  alt=""
                  class="active"
                />
                <span>{{ $t('common.textBook') }}</span>
              </router-link>
            </li>
            <li
              :class="{
                active: [
                  'settings_parkings',
                  'settings_parking_add',
                  'settings_parking_edit',
                ].includes($route.name),
              }"
            >
              <router-link
                :to="{ name: 'settings_parkings' }"
                data-toggle="accordion"
                data-target="#WIP"
                class="sub_menu no_arrow"
              >
                <img
                  :src="`${baseUrl}assets/media/images/icon/new-menu-ic4.png`"
                  alt=""
                  class="default"
                />
                <img
                  :src="`${baseUrl}assets/media/images/icon/new-menu-ic4-active.png`"
                  alt=""
                  class="active"
                />
                <span>{{ $t('sidebar.parking.parkings') }}</span>
              </router-link>
            </li>
            <li
              :class="{
                active: [
                  'unit_registration_list',
                  'unit_registration_add',
                  'unit_registration_edit',
                ].includes($route.name),
              }"
            >
              <router-link
                :to="{ name: 'unit_registration_list' }"
                data-toggle="accordion"
                data-target="#WIP"
                class="sub_menu no_arrow"
              >
                <img
                  :src="`${baseUrl}assets/media/images/icon/new-menu-ic4.png`"
                  alt=""
                  class="default"
                />
                <img
                  :src="`${baseUrl}assets/media/images/icon/new-menu-ic4-active.png`"
                  alt=""
                  class="active"
                />
                <span>{{ $t('sidebar.unitManagement.unitRegistration') }}</span>
              </router-link>
            </li>
          </ul>
        </li>
        <li
          :class="{
            active: [
              'seo_manage_index',
              'seo_manage_create',
              'seo_manage_edit',
            ].includes($route.name),
          }"
        >
          <router-link
            :to="{ name: 'seo_manage_index' }"
            data-toggle="accordion"
            data-target="#WIP"
            class="left_f_list no_arrow"
          >
            <img
              :src="`${baseUrl}assets/media/images/icon/new-menu-ic4.png`"
              alt=""
              class="default"
            />
            <img
              :src="`${baseUrl}assets/media/images/icon/new-menu-ic4-active.png`"
              alt=""
              class="active"
            />
            <span>{{ $t('sidebar.seo.seo_manage') }}</span>
          </router-link>
        </li>
        <li
          :class="{
            active: [
              'landing_page_list',
              'landing_page_add',
              'landing_page_edit',
            ].includes($route.name),
          }"
        >
          <router-link
            :to="{ name: 'landing_page_list' }"
            data-toggle="accordion"
            data-target="#WIP"
            class="left_f_list no_arrow"
          >
            <img
              :src="`${baseUrl}assets/media/images/icon/new-menu-ic1-.png`"
              alt=""
              class="default"
            />
            <img
              :src="`${baseUrl}assets/media/images/icon/new-menu-ic1-active.png`"
              alt=""
              class="active"
            />
            <span>랜딩페이지관리 </span>
          </router-link>
        </li>
      </template>
    </ul>
    <SlCategoryModal
      v-if="showSlCategoryModal"
      :showSlCategoryModal="showSlCategoryModal"
      @closeModal="closeSlCategoryModal"
    />
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import SlCategoryModal from './SlCategoryModal.vue';
export default {
  components: {
    SlCategoryModal,
  },
  data() {
    return {
      baseUrl: process.env.VUE_APP_BASE,
      showSlCategoryModal: false,
      specialLectureCategories: [],
    };
  },
  computed: {
    ...mapGetters({
      user: 'auth/getUser',
    }),
  },
  created() {
    this.axios
      .get('/special-lecture-categories')
      .then((response) => (this.specialLectureCategories = response.data.data));
  },
  mounted() {},
  methods: {
    openSlCategoryModal() {
      this.showSlCategoryModal = true;
    },
    closeSlCategoryModal() {
      this.axios
        .get('/special-lecture-categories')
        .then(
          (response) => (this.specialLectureCategories = response.data.data)
        );
      this.showSlCategoryModal = false;
    },
    logout() {
      this.axios.post('/logout').finally(() => {
        this.$store.dispatch('auth/logout');
        this.$router.push({ name: 'login' });
      });
    },
  },
};
</script>
<style scoped>
.d-block {
  display: block !important;
}
.d_none {
  display: none !important;
}

.sub_menu {
  padding: 12px 0px !important;
}
</style>
